import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DriveLookupService } from '../../my-account/test-papers/drive-lookup.service';
import { DigitalDownloadService } from '../../common-myaccount-service/digital-download.service'
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';

export interface DigitalResource {

  id: number;
  slug: string;
  title: string;
  description: string;
  category: string;
  level: string;
  icon: string;
  colorKey: string;
  fileType: string;
  fileSize: string;
  fileName: string;
  fileId: string;
  fileUrl: string;
  price: number;
  salePrice?: number | null;
  downloads: number;

}

export interface DriveProductMeta {
  fileName: string;
  slug?: string;
  title: string;
  description: string;
  category: string;
  level: string;
  icon: string;
  colorKey: string;
  price: number;
  salePrice?: number;
  downloads: number;
}

@Component({
  selector: 'app-digital-downloads',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  templateUrl: './digital-downloads.component.html',
  styleUrl: './digital-downloads.component.css',
})
export class DigitalDownloadsComponent {


 downloadsFolderId = '18elBWCvKM1tApaMB-MqoEqZ-qYh0wBmz'; 
   //downloadsFolderId = '1NR6CZCRQXOWOPDXQmweUVjUJiP9zGKun';

   apiKey = 'AIzaSyDR484mbUxUuZfrBH2DkmuUrS4oFXhNT9w';

   //apiKey = 'AIzaSyBMXBdVvYHryA1wNq47TgBpB6MPOgEyGio'; //PRODUCTION


  resources: DigitalResource[] = [];
  filteredResources: DigitalResource[] = [];


  categories: string[] = ['All'];
  activeCategory = 'All';
  searchQuery = '';

  

  constructor(
    private drive: DriveLookupService,
    private route: ActivatedRoute,
  ) {}


  ngOnInit(): void {
this.loadProductsFromDrive();

}


  loadProductsFromDrive(): void {

    this.drive
      .listChildFolders(
        this.downloadsFolderId,
        this.apiKey,

        {
          orderBy: 'name'
        }

      )

      .subscribe({
        next: (categoryFolders: any[]) => {
          if (!categoryFolders?.length) {
            console.log(
              'No digital download folders found'
            );
            return;
          }
          categoryFolders.forEach(folder => {
            this.loadCategoryProducts(folder);
          });
        },
        error: (err) => {
          console.error(
            'Failed loading category folders',
            err
          );
        }
      });
  }


  loadCategoryProducts(

    categoryFolder: any

  ): void {

    this.drive

      .findFileByExactName(

        categoryFolder.id,

        'products.json',

        this.apiKey

      )

      .subscribe({

        next: (jsonFile: any) => {

          if (!jsonFile) {

            console.warn(

              'products.json missing in',

              categoryFolder.name

            );

            return;

          }

          this.drive

            .loadJsonFile(

              jsonFile.id,

              this.apiKey

            )

            .subscribe({

              next: (

                productMetaList: DriveProductMeta[]

              ) => {

                this.drive

                  .listFilesInFolder(

                    categoryFolder.id,

                    this.apiKey

                  )

                  .subscribe({

                    next: (files: any[]) => {

                      this.mapProducts(

                        productMetaList,

                        files

                      );

                    },

                    error: (err) => {

                      console.error(

                        'Failed loading files',

                        err

                      );

                    }

                  });

              },

              error: (err) => {

                console.error(

                  'Failed loading products.json',

                  err

                );

              }

            });

        },

        error: (err) => {

          console.error(

            'Failed locating products.json',

            err

          );

        }

      });

  }

  mapProducts(

    productMetaList: DriveProductMeta[],

    files: any[]

  ): void {

    productMetaList.forEach(meta => {

      const file = files.find(f => {

        return (

          f.name &&

          f.name

            .toString()

            .trim()

            .toLowerCase() ===

          meta.fileName

            .toString()

            .trim()

            .toLowerCase()

        );

      });

      if (!file) {

        console.warn(

          'Matching file not found:',

          meta.fileName

        );

        return;

      }

      const resource: DigitalResource = {

  id: this.resources.length + 1,

  slug:
    meta.slug ||
    this.generateSlug(meta.title),

  title: meta.title,

  description: meta.description,

  category: meta.category,

  level: meta.level,

  icon: meta.icon,

  colorKey: meta.colorKey,

  fileType: this.getFileType(meta.fileName),

  fileSize: this.formatBytes(Number(file.size || 0)),

  fileName: meta.fileName,

  fileId: file.id,

  fileUrl: this.drive.buildDownloadUrl(file.id),

  price: meta.price,

  salePrice: meta.salePrice,

  downloads: meta.downloads || 0

};

      this.resources.push(resource);

    });

    this.filteredResources = [
      ...this.resources
    ];
    this.buildCategories();
  }

  buildCategories(): void {
    const uniqueCategories: string[] = [];
    this.resources.forEach(resource => {
      if (
        resource.category &&
        !uniqueCategories.includes(
          resource.category
        )
      ) {
        uniqueCategories.push(
          resource.category
        );
      }
    });

    uniqueCategories.sort();
    this.categories = [
      'All',
      ...uniqueCategories
    ];
  }

  generateSlug(title: string): string {

  return title
    .toLowerCase()
    .replace(/\+/g, 'plus')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

  setCategory(
    category: string
  ): void {
    this.activeCategory = category;
    this.filterResources();
  }

  filterResources(): void {

    const query =
      this.searchQuery
        .toLowerCase()
        .trim();
    this.filteredResources =
      this.resources.filter(resource => {
        const categoryMatch =
          this.activeCategory === 'All' ||
          resource.category ===
          this.activeCategory;
        const searchMatch =
          query === '' ||
          resource.title
            .toLowerCase()
            .includes(query) ||
          resource.description
            .toLowerCase()
            .includes(query) ||
          resource.category
            .toLowerCase()
            .includes(query) ||
          resource.level
            .toLowerCase()
            .includes(query);
        return (
          categoryMatch &&
          searchMatch
        );
      });
  }

  resetFilters(): void {
    this.activeCategory = 'All';
    this.searchQuery = '';
    this.filteredResources = [
      ...this.resources
    ];

  }

 

ngOnDestroy(): void {

  document.body.style.overflow = '';

}

  getDiscountPercentage(
    originalPrice: number,
    salePrice: number
  ): number {

    if (
      !originalPrice ||
      !salePrice
    ) {

      return 0;

    }

    return Math.round(
      (
        (
          originalPrice -
          salePrice
        ) /
        originalPrice
      ) * 100
    );

  }


  getFileType(
    fileName: string
  ): string {

    if (!fileName) {

      return 'FILE';

    }

    const parts =
      fileName.split('.');

    if (
      parts.length < 2
    ) {

      return 'FILE';

    }

    return (
      parts
        .pop()
        ?.toUpperCase() ||
      'FILE'
    );

  }

  formatBytes(
    bytes: number
  ): string {

    if (
      !bytes ||
      bytes === 0
    ) {

      return '0 Bytes';

    }

    const k = 1024;

    const sizes = [
      'Bytes',
      'KB',
      'MB',
      'GB'
    ];

    const i = Math.floor(
      Math.log(bytes) /
      Math.log(k)
    );

    return (
      parseFloat(
        (
          bytes /
          Math.pow(k, i)
        ).toFixed(1)
      ) +
      ' ' +
      sizes[i]
    );

  }


}
